export const themes = { DARK: 'dark' }
